/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blank_Frames_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure and insert blank frames between captions" |
*
* @param {Blank_Frames_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const blank_frames_description = /** @type {((inputs?: Blank_Frames_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blank_Frames_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurer et insérer des images vides entre les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren und einfügen Sie leere Rahmen zwischen den Untertiteln.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configura e inserisci cornici vuote tra le didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройте и вставьте пустые рамки между подписями.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configurar e insertar marcos en blanco entre subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置并在字幕之间插入空白帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション間に空白フレームを設定して挿入する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन के बीच खाली फ्रेम कॉन्फ़िगर करें और डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configure e insira quadros em branco entre as legendas.")
	return /** @type {LocalizedString} */ ("Configure and insert blank frames between captions")
});